import { CORE_SERVICE_URLS } from '../../../Constants/Urls.constants';
import { REQUEST_ACTIONS } from '../../../Constants/Actions.constants';
import { createRequestAction } from '../../../Helpers/Action.helpers';
import { Taxgroup } from '../../../Models/DTO/Taxgroup.model';
import { routeReplacer } from '../../../Helpers/String.helper';

export const requestTaxgroupsList = (domain: string) =>
  createRequestAction<Taxgroup>({
    name: REQUEST_ACTIONS.TAXGROUPS,
    url: routeReplacer(CORE_SERVICE_URLS.TAXGROUPS, { domain }),
    method: 'GET',
  });
